<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="冷藏箱编号" prop="coolerNo">
            <el-input
              clearable
              v-model="formData.coolerNo"
              :disabled="coolerNoDisabled || editType"
              :placeholder="
                coolerNoDisabled ? '系统自动生成' : '请输入冷藏箱编号'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="冷藏箱长度">
            <el-input-number
              style="width: 100%"
              clearable
              controls-position="right"
              v-model="formData.coolerLength"
              :min="0"
              size="mini"
              :max="162142895431250380000"
              :step="0.0001"
              :precision="4"
              placeholder="请输入冷藏箱长度"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="冷藏箱宽度">
            <el-input-number
              style="width: 100%"
              clearable
              controls-position="right"
              v-model="formData.coolerWidth"
              :min="0"
              size="mini"
              :max="162142895431250380000"
              :step="0.0001"
              :precision="4"
              placeholder="请输入冷藏箱宽度"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="冷藏箱高度">
            <el-input-number
              style="width: 100%"
              clearable
              controls-position="right"
              v-model="formData.coolerHeight"
              :min="0"
              size="mini"
              :max="162142895431250380000"
              :step="0.0001"
              :precision="4"
              placeholder="请输入冷藏箱高度"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="冷藏箱容量" prop="boxType" size="small">
            <dict-select
              clearable
              v-model="formData.boxType"
              placeholder="请选择冷藏箱容量"
              default
              filterable
              size="small"
              style="width: 99%"
              :body="selectBoxType"
              :selectedLabel.sync="formData.boxTypeName"
              :disabled="disabled"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="冷藏箱材质" prop="coolerMaterial" size="small">
            <dict-select
              clearable
              v-model="formData.coolerMaterial"
              placeholder="请选择冷藏箱材质"
              default
              filterable
              size="small"
              style="width: 99%"
              :body="selectCoolerMaterial"
              :selectedLabel.sync="formData.coolerMaterialName"
              :disabled="disabled"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="调度订单编号" v-if="disabled">
            <el-input
              v-model.trim="formData.dispatchOrderNo"
              placeholder="请输入订单编号"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="可用状态">
            <el-radio-group v-model="formData.coolerStatus">
              <el-radio label="Y" name="type">有效</el-radio>
              <el-radio label="N" name="type">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    coolerCode: String,
    editType: Boolean,
    isAddPage: Boolean,
  },
  data() {
    return {
      selectBoxType: { type: 'boxType' },
      selectCoolerMaterial: { type: 'coolerMaterial' },
      formData: { coolerStatus: 'Y' },
      backDialogVisible: false,
      coolerNoDisabled: true,
      rules: {
        coolerNo: [
          {
            required: true,
            message: '请输入冷藏箱编号',
            trigger: 'blur',
          },
        ],
        dispatchOrderNo: [
          { required: true, message: '请输入调度订单编号', trigger: 'blur' },
        ],
        boxType: [
          {
            required: true,
            message: '请选择冷藏箱容量',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.querySysParams()
    this.getData()
  },
  methods: {
    getData() {
      if (!this.coolerCode) return
      this.$api
        .masterCoolerDetailApi({
          coolerCode: this.coolerCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterCoolerSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },

    querySysParams() {
      this.$api
        .getSysParameterByIdApi({ paramID: 'autoCooler' }) //bizOrderPackingQueryStatusApi
        .then((res) => {
          this.coolerNoDisabled = res.body.paramValue === 'Y' //Y为自动生成，N为手动填写
          if (this.coolerNoDisabled && this.isAddPage) {
            this.rules.coolerNo.shift()
          }
        })
    },
  },
}
</script>
